<template>
  <sp-text-field
    readonly
    clearable
    persistent-clear
    class="activator"
    color="surface"
    :value="value"
    :placeholder="placeholder"
    part="text-field"
    @click-clear="$emit('clear')"
  >
    <sp-icon
      v-if="prependIcon"
      slot="prepend"
      class="default-filter__activator-icon"
      :name="prependIcon"
      fill-color="var(--sp-comp-filter-default-activator-icon-fill-color)"
    />
    <sp-icon v-if="appendIcon" slot="append" class="default-filter__clear-icon" :name="prependIcon" />
  </sp-text-field>
</template>

<script setup>
import { computed } from "vue";

defineEmits(["clear"]);

const props = defineProps({
  value: {
    type: String,
    default: undefined,
  },
  label: {
    type: String,
    required: true,
  },
  prependIcon: {
    type: String,
    default: undefined,
  },
  appendIcon: {
    type: String,
    default: undefined,
  },
  closeOnSelect: {
    type: [Boolean, String],
    default: false,
  },
});

const placeholder = computed(() => props.value ?? props.label);
</script>

<style scoped lang="scss">
@import "../../../../../../assets/stylesheets/mixins/breakpoint";

.activator {
  --activator-height: 44px;
  --activator-border-color: var(--sp-sys-form-field-border-color);
  --activator-border-width: 1px;
  --activator-border-radius: var(--sp-sys-form-field-border-radius);
  --activator-color: #656f75;

  --sp-comp-text-field-color: var(--activator-color);
  --sp-comp-text-field-padding-inline: var(--sp-ref-spacing-4);
  --sp-comp-text-field-placeholder-color: var(--activator-border-color);
  --sp-comp-text-field-background-color: white;
  --sp-comp-text-field-border-color: var(--activator-border-color);
  --sp-comp-text-field-border-width: var(--activator-border-width);
  --sp-comp-text-field-border-radius: var(--activator-border-radius);
  --sp-comp-text-field-min-height: var(--activator-height);
  --sp-comp-text-field-cursor: pointer;
  --sp-comp-default-activator-text-field-padding-inline: var(--sp-ref-spacing-5);
  --sp-comp-text-field-content-padding-inline: var(--sp-comp-default-activator-text-field-padding-inline);

  @include sp-breakpoint(sm) {
    --button-justify-content: start;
    --activator-height: var(--sp-comp-default-filter-activator-height, 3.625rem);
    --activator-border-radius: 0;
    --sp-comp-text-field-border-width: var(--activator-border-width);

    margin-bottom: 0;
  }

  &:focus,
  &:focus-visible,
  &:focus-within {
    outline: none;
    box-shadow: none;
  }

  .activator__title {
    font-size: var(--activator-title-font-size, var(--sp-ref-font-size-medium));
    font-family: var(--activator-title-font-family, var(--sp-sys-font-family-normal));
    white-space: nowrap;
    position: relative;
    text-overflow: ellipsis;
    width: 100%;
    overflow: hidden;
  }
}
.default-filter__activator-icon {
  --fill: var(--sp-sys-color-primary);
}
</style>
